<div class="selected-template">
  <span class="template-title">
    {{ selectedTemplateTitle }}
  </span>
  @if (!isUKFeaturesEnabled()) {
    <span>
      <button class="change-template-btn" (click)="openTemplates()">{{ 'template.changeTemplate' | translate }}</button>
    </span>
  }
</div>
<div class="compareview-heading">
  <h3 class="print-hidden">
    {{ ('user.' + reportData().entity | translate | uppercase) + ' ' + ('reports.compareViewList' | translate) }}
  </h3>
  <span class="print-hidden">{{ recordList()?.length }} {{ 'reports.compareViewRecords' | translate }}</span>
</div>
<div class="divider"></div>
